import { render, staticRenderFns } from "./RoleFeatureList.vue?vue&type=template&id=0c2aebb0&scoped=true"
import script from "./RoleFeatureList.vue?vue&type=script&lang=js"
export * from "./RoleFeatureList.vue?vue&type=script&lang=js"
import style0 from "./RoleFeatureList.vue?vue&type=style&index=0&id=0c2aebb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2aebb0",
  null
  
)

export default component.exports